import React from 'react';
import { func, node, bool, number } from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import Icon from '../icon';
import { actions } from './state';

// TODO: draw step pending state
const Step = ({
  title,
  active,
  error,
  completed,
  disabled,
  enabled,
  index,
  goAt,
}) => (
  <li
    role="menuitem"
    tabIndex="0"
    onClick={!disabled && enabled ? (() => goAt(index)) : undefined}
    className={classnames(
      'mdc-step',
      {
        'mdc-step--completed': completed,
        'mdc-step--error': error,
        'mdc-step--active': active,
        'mdc-step--disabled': disabled,
        'mdc-step--enabled': enabled,
      },
    )}
  >
    <span className="mdc-step__label">
      <span className="mdc-step__title">
        <span className="mdc-step__title-text">
          {title}
        </span>
      </span>
      <span className="mdc-step__label-indicator">
        <span className="mdc-step__label-indicator-content">
          {completed
            ? <Icon>check</Icon>
            : index
          }
        </span>
      </span>
    </span>
  </li>
);

Step.propTypes = {
  index: number.isRequired,
  title: node.isRequired,
  active: bool,
  completed: bool,
  disabled: bool,
  enabled: bool,
  error: bool,
  goAt: func.isRequired,
};

Step.defaultProps = {
  active: false,
  completed: false,
  error: false,
  disabled: false,
  enabled: false,
};

export default connect(null, {
  goAt: actions.go,
})(Step);
